export default __webpack_public_path__ + "static/media/img-hero-precisando.e72f4adc.png";